import { render, staticRenderFns } from "./DealerCopyNotificationsFields.vue?vue&type=template&id=5c7a537c&scoped=true"
import script from "./DealerCopyNotificationsFields.vue?vue&type=script&lang=js"
export * from "./DealerCopyNotificationsFields.vue?vue&type=script&lang=js"
import style0 from "./DealerCopyNotificationsFields.vue?vue&type=style&index=0&id=5c7a537c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7a537c",
  null
  
)

export default component.exports